import { View } from 'react-native';
import styled from 'styled-components/native';

export const Container = styled(View)`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const IconWrapper = styled(View)``;
